import { Outlet, RouteObject, useParams } from 'react-router'
import { ObjectTypes } from '../api/object'
import { useTableLayout } from '../layouts'
import { ObjectCreate } from '../objects/object-create'
import { ObjectEdit } from '../objects/object-edit'
import { ObjectsTable } from '../objects/objects'
import { Activity } from '../widget/activity'
import { Base } from './base'
import { DEFAULT_FORM_DATA } from './client-configuration'
import { ReservationDamageAnalysisRoute } from './damage-analysis'
import { DamageAnalyticsRoute } from './damage-dashboard'
import { Form } from './form'
import { Root } from './root'
import { Table } from './table'
import { ReservationWorkflowRequestsRoute } from './workflow-requests'

export const RESERVATIONS_ROUTES: RouteObject = {
	path: 'reservation/*',
	element: <Root />,
	children: [
		{
			path: '',
			index: true,
			element: <Table />,
		},
		{
			path: 'create',
			index: true,
			element: <Form data={DEFAULT_FORM_DATA} redirect />,
		},
		{
			path: 'damage-analytics',
			element: <DamageAnalyticsRoute />,
		},
		{
			path: ':reservationId',
			element: <Outlet />,
			children: [
				{
					index: true,
					element: <Base />,
				},
				{
					path: 'logs',
					element: <ActivityRoute />,
				},
				{
					path: 'handover-return',
					element: <ReservationWorkflowRequestsRoute />,
				},
				{
					path: 'damage',
					element: <ReservationDamageAnalysisRoute />,
				},
				{
					path: ':object',
					children: [
						{
							index: true,
							element: <RelatedObjects />,
						},
						{
							path: 'create',
							element: <ObjectCreate />,
						},
						{
							path: ':id',
							element: <ObjectEdit />,
						},
					],
				},
			],
		},
	],
}

function RelatedObjects() {
	const { reservationId = '', object = '' } = useParams()
	const { layout, isLoading } = useTableLayout(object, 'reservation', {
		type: 'relation',
	})

	if (isLoading) return null
	if (!layout) return null

	return (
		<ObjectsTable
			table={layout}
			object={object as keyof ObjectTypes}
			related={{ reservation_id: reservationId }}
		/>
	)
}

export function ActivityRoute() {
	const { reservationId = '' } = useParams()
	return <Activity object="reservation" id={reservationId} />
}
